import { errorMessages } from 'constants/errors';
import { asyncActionsNames, reducersNames } from 'constants/reducers';

import { createThunk } from 'utils';

import {
  getInterceptionById,
  getInterceptionDepartments,
  getInterceptionMemberById,
  getInterceptionMembers,
  getInterceptionNetworkById,
  getInterceptionNetworks,
  getInterceptionsList,
  getInterceptionTranscriptsById,
  updateInterceptionMemberById,
  updateInterceptionNetworkById,
} from '../../../api/interception';
import {
  GetInterceptionMemberRequestParams,
  GetInterceptionNetworkRequestParams,
  GetInterceptionsRequestParams,
  Interception,
  InterceptionDepartment,
  InterceptionMember,
  InterceptionNetwork,
  InterceptionTranscriptSegment,
  UpdateInterceptionMemberRequestParams,
  UpdateInterceptionNetworkRequestParams,
} from '../../../interfaces/interceptions';

export const getInterceptionsListThunk = createThunk<
  Interception[],
  GetInterceptionsRequestParams
>(
  `${reducersNames.INTERCEPTIONS}/${asyncActionsNames.GET_INTERCEPTIONS_LIST}`,
  getInterceptionsList,
  errorMessages.GET_INTERCEPTIONS_ERROR
);

export const getInterceptionByIdThunk = createThunk<Interception, number>(
  `${reducersNames.INTERCEPTIONS}/${asyncActionsNames.GET_INTERCEPTION_BY_ID}`,
  getInterceptionById,
  errorMessages.GET_INTERCEPTION_BY_ID_ERROR
);

export const getInterceptionTranscriptsByIdThunk = createThunk<
  InterceptionTranscriptSegment[],
  number
>(
  `${reducersNames.INTERCEPTIONS}/${asyncActionsNames.GET_INTERCEPTION_TRANSCRIPTS_BY_ID}`,
  getInterceptionTranscriptsById,
  errorMessages.GET_INTERCEPTION_BY_ID_ERROR
);

export const getInterceptionDepartmentsThunk = createThunk<
  InterceptionDepartment[],
  void
>(
  `${reducersNames.INTERCEPTIONS}/${asyncActionsNames.GET_INTERCEPTION_DEPARTMENTS}`,
  getInterceptionDepartments,
  errorMessages.GET_INTERCEPTION_DEPARTMENTS_ERROR
);

export const updateInterceptionNetworkByIdThunk = createThunk<
  InterceptionNetwork,
  UpdateInterceptionNetworkRequestParams
>(
  `${reducersNames.INTERCEPTIONS}/${asyncActionsNames.UPDATE_INTERCEPTION_NETWORK_BY_ID}`,
  updateInterceptionNetworkById,
  errorMessages.UPDATE_INTERCEPTION_NETWORK_ERROR
);

export const updateInterceptionMemberByIdThunk = createThunk<
  InterceptionMember,
  UpdateInterceptionMemberRequestParams
>(
  `${reducersNames.INTERCEPTIONS}/${asyncActionsNames.UPDATE_INTERCEPTION_MEMBER_BY_ID}`,
  updateInterceptionMemberById,
  errorMessages.UPDATE_INTERCEPTION_MEMBER_ERROR
);

export const getInterceptionMembersThunk = createThunk<
  InterceptionMember[],
  GetInterceptionNetworkRequestParams
>(
  `${reducersNames.INTERCEPTIONS}/${asyncActionsNames.GET_INTERCEPTION_MEMBERS}`,
  getInterceptionMembers,
  errorMessages.GET_ATTRIBUTES_ERROR
);

export const getInterceptionNetworksThunk = createThunk<
  InterceptionNetwork[],
  GetInterceptionMemberRequestParams
>(
  `${reducersNames.INTERCEPTIONS}/${asyncActionsNames.GET_INTERCEPTION_NETWORKS}`,
  getInterceptionNetworks,
  errorMessages.GET_INTERCEPTION_NETWORK_BY_ID_ERROR
);

export const getInterceptionNetworkByIdThunk = createThunk<
  InterceptionNetwork,
  string
>(
  `${reducersNames.INTERCEPTIONS}/${asyncActionsNames.GET_INTERCEPTION_NETWORK_BY_ID}`,
  getInterceptionNetworkById,
  errorMessages.GET_INTERCEPTION_NETWORK_BY_ID_ERROR
);

export const getInterceptionMemberByIdThunk = createThunk<
  InterceptionMember,
  string
>(
  `${reducersNames.INTERCEPTIONS}/${asyncActionsNames.GET_INTERCEPTION_MEMBER_BY_ID}`,
  getInterceptionMemberById,
  errorMessages.GET_INTERCEPTION_MEMBER_BY_ID_ERROR
);
